import { apiSlice } from "../apiSlice";

export const CertificationSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getCertification: builder.query({
      query: ({ page, query, certificate_id }) => {
        let url = "/org/get_all_certifications?";

        // Append page if it is defined
        if (page !== undefined) {
          url += `page=${page}`;
        }
        // Append query if available
        if (query) {
          url += `${url.endsWith("?") ? "" : "&"}${query}`;
        }

        // Append certificate_id if available
        if (certificate_id !== undefined) {
          url += `${
            url.endsWith("?") ? "" : "&"
          }certificate_id=${certificate_id}`;
        }

        return url;
      },
      providesTags: (result) =>
        result
          ? [
              { type: "Certification", id: "LIST" },
              ...result.data.map((item) => ({
                type: "Certification",
                id: item.id,
              })),
            ]
          : [{ type: "Certification", id: "LIST" }],
      keepUnusedDataFor: 0,
    }),

    addCertification: builder.mutation({
      query: (certidata) => ({
        url: "/org/certifications/",
        method: "POST",
        body: certidata,
      }),
    }),
    editCertification: builder.mutation({
      query: (certidata) => ({
        url: "/org/certifications/",
        method: "PUT",
        body: certidata,
      }),
    }),
    deleteCertification: builder.mutation({
      query: ({ certification_id }) => ({
        url: `/org/certifications/?certification_id=${certification_id}`,
        method: "DELETE",
      }),
    }),
    shareCertification: builder.mutation({
      query: (certidata) => ({
        url: "/org/assign_certifications/",
        method: "POST",
        body: certidata,
      }),
      invalidatesTags: [{ type: "Certification", id: "LIST" }],
    }),
    getMyCertifications: builder.query({
      query: ({ page, query, assigned_id }) => {
        let url = "/org/get_my_certifications?";

        // Append page if it is defined
        if (page !== undefined) {
          url += `page=${page}`;
        }
        // Append query if available
        if (query) {
          url += `${url.endsWith("?") ? "" : "&"}${query}`;
        }
        // Append certificate_id if available
        if (assigned_id !== undefined) {
          url += `${url.endsWith("?") ? "" : "&"}assigned_id=${assigned_id}`;
        }
        return url;
      },
      keepUnusedDataFor: 0,
    }),
    editMyCertifications: builder.mutation({
      query: (certificatedata) => ({
        url: "/org/update_my_certifications/",
        method: "PUT",
        body: certificatedata,
      }),
    }),
  }),
});

export const {
  useGetCertificationQuery,
  useAddCertificationMutation,
  useEditCertificationMutation,
  useDeleteCertificationMutation,
  useShareCertificationMutation,
  useGetMyCertificationsQuery,
  useEditMyCertificationsMutation,
} = CertificationSlice;
